import { ThemeProvider } from '@emotion/react';
import { CookiesProvider } from 'react-cookie';
import Home from 'pages/main';
import Make from 'pages/myshop/make';
import Style from 'pages/myshop/style';
import List from 'pages/myshop/list';
import Calc from 'pages/myshop/calc';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import GlobalStyle from './styles/global';
import theme from './styles/theme';
import Intro from 'pages/intro/indx';
import Guide from 'pages/business/guide';
import Shop from 'pages/business/shop';
import Inquiry from 'pages/inquiry';
import Terms from 'pages/terms';
import Event from 'pages/event';
import Promotion from 'pages/promotion';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/myshop/make',
    element: <Make />,
  },
  {
    path: '/myshop/style',
    element: <Style />,
  },
  {
    path: '/myshop/list',
    element: <List />,
  },
  {
    path: '/myshop/calc',
    element: <Calc />,
  },
  {
    path: '/intro',
    element: <Intro />,
  },
  {
    path: '/business/guide',
    element: <Guide />,
  },
  {
    path: '/business/shop',
    element: <Shop />,
  },
  {
    path: '/inquiry',
    element: <Inquiry />,
  },
  {
    path: '/terms/:id',
    element: <Terms />,
  },
  {
    path: '/event/:id',
    element: <Event />,
  },
  {
    path: '/promotion',
    element: <Promotion />,
  },
]);

const App = () => (
  <CookiesProvider>
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <RouterProvider router={router} />
    </ThemeProvider>
  </CookiesProvider>
);

export default App;
